import Vue from 'vue'
import store from '@store'
import main from './main.vue'
import AudioSoundHost from '@views/question-review/components/AudioSoundHost'
// 全屏证据弹窗样式；从非审单页打开时也需加载（如录音风险列表）
import '@views/question-review/question-review.scss'

const MainConstructor = Vue.extend(main)

let instance

/** 每次打开前重置，避免单例残留（如 orderDetail）污染只读入口 */
const EPHEMERAL_DEFAULTS = {
  type: null,
  viewIndex: 0,
  files: [],
  question: {},
  questionIndex: 0,
  toolbar: {},
  getLableData: Function.prototype,
  orderDetail: {},
  onClose: null,
  onDrawSavedFunc: null,
  drawSaving: false,
}

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
    store,
  })
  document.body.appendChild(instance.$el)
}

const AnswerFileFullScreen = function (options = {}) {
  if (!instance) {
    initInstance()
  }
  Object.keys(EPHEMERAL_DEFAULTS).forEach((key) => {
    instance[key] = EPHEMERAL_DEFAULTS[key]
  })
  for (const key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key]
    }
  }
  instance.visible = true
}

AnswerFileFullScreen.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
  // 出声源 / Document PiP 与证据弹窗解耦，离开页面时统一回收
  AudioSoundHost.destroy()
}

export default AnswerFileFullScreen
export { AnswerFileFullScreen }



// WEBPACK FOOTER //
// ./src/views/question-review/components/AnswerFileFullScreen/src/main.js